import { Permissions } from 'src/auth/permissions/constants';
import { IsideBarOptions } from '@playsistemico/modo-ui-portal-lib/molecules/SideBar';
import blankIcon from 'src/global/assets/icons/blank.svg';
import { IconSize } from '@playsistemico/modo-ui-portal-lib/atoms/Icon/constants';

interface SideBarOptionsProps extends IsideBarOptions {
  permission?: Permissions.PermissionsList;
  anyOf?: Permissions.PermissionsList[];
}

export const sidebarOptions : SideBarOptionsProps[] = [
    {
      key: 'transactions',
      name: 'Mis Pagos',
      to: '/transactions',
      anyOf: [
        Permissions.PermissionsList.ReadTransactions,
        Permissions.PermissionsList.DownloadTransactions,
        Permissions.PermissionsList.ManageTransactions
      ],
      // H1: items del portal en texto solo. El DS exige `icon: string`, por eso un SVG en blanco.
      icon: blankIcon,
      iconSize: IconSize.XSMALL
    }
];

export const HIDE_SIDEBAR_ROUTES = ['/new-debit-info'];
